import { TIntroducerApplication } from 'lendingApi/applications.types';

export type TRefinancingData = NonNullable<
  TIntroducerApplication['refinancing']
>;
export type TRefinancingDebtData = TRefinancingData['debts'][number];

export type TFacilityType =
  | 'term_loan'
  | 'hire_purchase'
  | 'invoice_finance'
  | 'overdraft'
  | 'credit_card'
  | 'revolving_facility'
  | 'other';

export type TRefinancingDebt = {
  lenderName?: string;
  facilityType?: TFacilityType | '';
  outstandingBalance?: string;
  // Conditional fields, driven by facilityType.
  creditLimit?: string;
  monthlyRepayment?: string;
  lastRepaymentDate?: string;
  otherDescription?: string;
};

export type TRefinancing = {
  debts: TRefinancingDebt[];
  usesLoanToClearDebts?: boolean;
  hasEnteredAllDebts?: boolean;
};

export type TConditionalFieldName =
  | 'creditLimit'
  | 'monthlyRepayment'
  | 'lastRepaymentDate';

export type TConditionalField = {
  name: TConditionalFieldName;
  optional?: boolean;
};

export const FACILITY_OPTIONS: { value: TFacilityType; label: string }[] = [
  { value: 'term_loan', label: 'Term loan' },
  { value: 'hire_purchase', label: 'Hire purchase' },
  { value: 'invoice_finance', label: 'Invoice finance' },
  { value: 'overdraft', label: 'Overdraft' },
  { value: 'credit_card', label: 'Credit card' },
  { value: 'revolving_facility', label: 'Revolving facility' },
  { value: 'other', label: 'Other' },
];

export const FACILITY_FIELDS: Record<TFacilityType, TConditionalField[]> = {
  term_loan: [{ name: 'monthlyRepayment' }, { name: 'lastRepaymentDate' }],
  hire_purchase: [{ name: 'monthlyRepayment' }, { name: 'lastRepaymentDate' }],
  invoice_finance: [{ name: 'creditLimit' }],
  overdraft: [{ name: 'creditLimit' }],
  credit_card: [{ name: 'creditLimit' }],
  revolving_facility: [{ name: 'creditLimit' }],
  other: [
    { name: 'monthlyRepayment', optional: true },
    { name: 'lastRepaymentDate', optional: true },
  ],
};

// `other` couples an extra description input directly beneath the facility
export const FACILITY_WITH_DESCRIPTION: TFacilityType = 'other';
